export function Spinner({ label = 'Loading' }: { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center justify-center gap-3 text-ink-muted py-12"
    >
      <span className="h-5 w-5 rounded-full border-2 border-navy-900/20 border-t-navy-900 animate-spin" />
      <span className="text-sm">{label}…</span>
    </div>
  );
}

export function Skeleton({ className = '' }: { className?: string }) {
  return <div className={`animate-pulse rounded-md bg-slate-200 ${className}`} />;
}
